module.exports = __webpack_public_path__ + "static/img/strong_16.9f054b79.png";